export const DEFAULT_QA_ACCOUNT_EMAIL_MARKERS: readonly string[] = [
  "michele.giordano",
  "kristina.poberezhna",
  "filippo.mussoni",
];

export function parseQaAccountEmailMarkers(
  rawValue: string | undefined,
  defaultMarkers: readonly string[] = DEFAULT_QA_ACCOUNT_EMAIL_MARKERS
): string[] {
  if (rawValue === undefined) return [...defaultMarkers];

  return rawValue
    .split(",")
    .map(function trimMarker(marker) {
      return marker.trim().toLowerCase();
    })
    .filter(Boolean);
}

export function isQaAccountEmail(email: string | undefined, emailMarkers: readonly string[]): boolean {
  if (!email) return false;

  const normalizedEmail = email.toLowerCase();
  return emailMarkers.some(function matchesMarker(marker) {
    return normalizedEmail.includes(marker);
  });
}

export const qaAccountEmailMarkers = parseQaAccountEmailMarkers(process.env.REACT_APP_QA_ACCOUNT_EMAILS);

let isQaAccountSession = false;

export function markQaAccountSession(email: string | undefined): void {
  isQaAccountSession = isQaAccountEmail(email, qaAccountEmailMarkers);
}

export function isQaAccountSessionActive(): boolean {
  return isQaAccountSession;
}

export function clearQaAccountSession(): void {
  isQaAccountSession = false;
}
